export * from './gamesSystemProperties.interface';